import { inject, injectable } from "inversify";
import { ApiPage } from "@/core/models/page.model";
import { TableRepo } from "../table.repo";
import { WaterSupplySuspensionLevelModel } from "@/core/models/water-supply-suspension-level.model";
import { AddressRepo } from "../address.repo";
import { TollAreaRepo } from "./toll-area.repo";
import { TollAreaModel } from "@/core/models/toll-area/toll-area.model";

interface _WaterSupplySuspensionLevelGetParams {
    search?: string;
}

@injectable()
export class WaterSupplySuspensionLevelRepo extends TableRepo<WaterSupplySuspensionLevelModel> {
    @inject(AddressRepo)
    private addressRepo!: AddressRepo;

    @inject(TollAreaRepo)
    private tollAreaRepo!: TollAreaRepo;
    
    constructor() {
        super("/api/WaterSupplySuspensionLevel");
    }

    async getData(index: number, params: _WaterSupplySuspensionLevelGetParams, pageSize = 10): Promise<ApiPage<WaterSupplySuspensionLevelModel>|null> {
        const result = await super.getData(index, params, pageSize)
        if (result) {
            const data: WaterSupplySuspensionLevelModel[] = [];
            const tollAreas: TollAreaModel[] = await this.tollAreaRepo.getAll();
            for (const record of result.data) {
                const [province, district, ward] = await Promise.all([
                    this.addressRepo.getProvince(record.provinceId),
                    this.addressRepo.getDistrict(record.districtId),
                    this.addressRepo.getWard(record.wardId),
                ]);
                const populatedRecord: WaterSupplySuspensionLevelModel = {
                    ...record,
                    provinceName: province?.name,
                    districtName: district?.name,
                    wardName: ward?.name,
                    tollAreaName: record.tollAreaId
                        ? tollAreas.find(area => area.id === record.tollAreaId)?.name
                        : "Tất cả khu vực",
                };
                data.push(populatedRecord);
            }
            result.data = data;
            return result;
        }
        return null;
    }
}
